import { render, staticRenderFns } from "./card-with-image.vue?vue&type=template&id=c81932ea&scoped=true&"
import script from "./card-with-image.vue?vue&type=script&lang=js&"
export * from "./card-with-image.vue?vue&type=script&lang=js&"
import style0 from "./card-with-image.vue?vue&type=style&index=0&id=c81932ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81932ea",
  null
  
)

export default component.exports